const axios = require('axios');
export default class Ajax {
    static get(url, params = {}) {
        return axios.get(url, {
            params: params,
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        });
    }

}


// WEBPACK FOOTER //
// /src/common/ajax.js